var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right text-12px font-hirakaku-w3 text-font-black",class:_vm.isMobile ? 'p-10px' : 'p-30px'},[_vm._v(" ©2021 ADVENTURE inc. All rights reserved. ")])}
var staticRenderFns = []

export { render, staticRenderFns }